<template>
  <div class="signup">
    <Sidebar />
    <Form :signup="true" msg="Sign Up" @formSubmitted="signupUser($event)" />
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/accounts/sidebar";
import Form from "@/components/accounts/form";
export default {
  name: "Signup",
  components: {
    Sidebar,
    Form
  },
  methods: {
    signupUser(data) {
      console.log(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.signup {
  min-height: 100vh;
}
</style>
